var _Defs, _G, _Use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, LinearGradient, Stop, Symbol as _Symbol, Circle, Path, ClipPath, G, Use } from "react-native-svg";
function SvgSunnyWindy(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "sunny_windy_svg__a",
    x1: 96,
    y1: -2.35,
    x2: 168,
    y2: 122.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#bec1c6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#bec1c6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#959aa2"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "sunny_windy_svg__c",
    y1: -50.35,
    x2: 168,
    y2: 74.35,
    xlinkHref: "#sunny_windy_svg__a"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#bec1c6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#bec1c6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#959aa2"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "sunny_windy_svg__b",
    x1: 149.99,
    y1: 119.24,
    x2: 234.01,
    y2: 264.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#f59e0b"
  })), /*#__PURE__*/React.createElement(_Symbol, {
    id: "sunny_windy_svg__e",
    viewBox: "0 0 384 384"
  }, /*#__PURE__*/React.createElement(Circle, {
    cx: 192,
    cy: 192,
    r: 84,
    stroke: "#f8af18",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    fill: "url(#sunny_windy_svg__b)"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M192 61.66V12m0 360v-49.66m92.17-222.51l35.11-35.11M64.72 319.28l35.11-35.11m0-184.34L64.72 64.72m254.56 254.56l-35.11-35.11M61.66 192H12m360 0h-49.66",
    fill: "none",
    stroke: "#fbbf24",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 24
  })), /*#__PURE__*/React.createElement(_Symbol, {
    id: "sunny_windy_svg__f",
    viewBox: "0 0 348 240"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M267.16 24.29A40 40 0 11296 92H12",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 24,
    stroke: "url(#sunny_windy_svg__a)"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M151.16 215.71A40 40 0 10180 148H12",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 24,
    stroke: "url(#sunny_windy_svg__c)"
  })), /*#__PURE__*/React.createElement(ClipPath, {
    id: "sunny_windy_svg__d"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "none",
    d: "M0 0h512v306H0z"
  })))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#sunny_windy_svg__d)"
  }, /*#__PURE__*/React.createElement(Use, {
    width: 384,
    height: 384,
    transform: "translate(64 100)",
    xlinkHref: "#sunny_windy_svg__e"
  }))), _Use || (_Use = /*#__PURE__*/React.createElement(Use, {
    width: 129,
    height: 110,
    transform: "translate(191.5 300.5)",
    xlinkHref: "#sunny_windy_svg__f"
  })));
}
export default SvgSunnyWindy;